module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_NuezIndiaSalada.a4a06635.pdf";